export default function handleCopyUrl(selector) {
  const button = document.querySelector(selector);
  if (!button) return;

  button.addEventListener('click', () => {
    const postUrl = window.location.href;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(postUrl)
        .then(() => {
          button.classList.add('copied');
          setTimeout(() => button.classList.remove('copied'), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  });
}
